import styled from 'styled-components';

export const OverwriteMainContainer = styled.div`
  position: relative;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.placeholderBackground} 0%,
    ${({ theme }) => theme.placeholderBackground}F8 100%
  );
  border-radius: 8px;
  width: 99%;
  height: calc(100vh - 305px);
  /* padding-bottom: 1vh; */
  padding: 0;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* border: 1px solid ${({ theme }) => theme.border}30; */

  .action-buttons-container {
    position: absolute;
    bottom: 0.1vh;
    right: 1vw;
    width: 100%;
    z-index: 20; /* Dodano da se osigura da gumbi budu iznad tablice */
    padding-top: 500px;
    display: flex;
    justify-content: end;
    gap: 0.6vw;
    margin-top: 1vw;
  }
  &:hover {
    .edit-btns {
      display: flex;
      flex-direction: row;
      gap: 5px;
      background-color: transparent;
    }
  }

  .edit-btns {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 20; /* Dodano da se osigura da gumbi budu iznad tablice */

    .edit-btn {
      font-weight: 300;
      box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.1),
        0 1px 3px rgba(0, 0, 0, 0.08);
      border-radius: 50%;
      cursor: pointer;
      padding: 6px;
      transition: all 0.2s ease;
      background: ${({ theme }) => theme.c50};
      color: ${({ theme }) => theme.brand};
      border: 1px solid ${({ theme }) => theme.c100}40;

      &:hover {
        outline: 1px solid ${({ theme }) => theme.c200};
        box-shadow:
          0 3px 12px rgba(0, 0, 0, 0.15),
          0 2px 6px rgba(0, 0, 0, 0.1);
        transform: scale(1.05);
        background: ${({ theme }) => theme.c100};
      }
    }
  }
`;

export const SingleColumn = styled.div`
  width: 13.72vw;
  padding: 1.04vw;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${({ theme }) => theme.border};
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  /* justify-content: center; */
  /* align-items: center; */
  height: 100%;
  input {
    width: 100%;
    margin-bottom: 0.5vw;
  }

  .header {
    font-size: 1.04vw;
    font-family: 'FontMedium';
    font-weight: normal;
    color: ${({ theme }) => theme.primaryGray};
    padding: 0.89vw 0.73vw;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    margin-bottom: 0.24vw;
  }
  .elementsContainer {
    overflow-y: scroll;

    &::-webkit-scrollbar {
      background-color: ${({ theme }) => theme.placeholderBackground};
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      background-color: ${({ theme }) => theme.scrollThumb};
    }

    &::-webkit-scrollbar {
      display: none;
    }

    & {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  }
`;

export const StyledLabel = styled.label`
  cursor: pointer;
  background: transparent;
  /*     border: 1px solid ${({ theme }) => theme.primaryGray};
    border-radius: 7px; */
  /* width: fit-content; */
  /* margin-bottom: 8px; */
  /* margin-top: 21px; */
  font-family: 'FontMedium', sans-serif;
  color: ${({ theme }) => theme.primaryGray};
  display: flex;
  margin-bottom: 0.24vw;
  max-width: 13vw;

  input {
    display: none;
  }
  .checked {
    padding: 0.4vw 0.63vw; /* 0.17vw 0.43vw; */
    max-width: 16vw;
    span {
      font-size: 0.63vw;
      font-family: 'FontMedium';
      font-weight: normal;
      color: ${({ theme }) => theme.primaryGray};
      word-wrap: break-word;
    }
  }

  input:checked ~ .checked {
    /* border: 1px solid ${({ theme }) => theme.primaryGray}; */
    background-color: ${({ theme }) => theme.border};
    border-radius: 7px;
    width: 100%;
  }
  &:hover {
    background-color: ${({ theme }) => theme.c50};
    border-radius: 7px;
    /* border: 1px solid ${({ theme }) => theme.primaryGray}; */
    width: 100%;
  }
`;

export const DetailsPane = styled.div`
  width: calc(99% - (13.72vw * 4));
  /* padding: 6vw; */
  padding-top: 2vw;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  height: 100%;

  .header {
    font-size: 1.25vw;
    font-family: 'FontMedium';
    font-weight: normal;
    color: ${({ theme }) => theme.primaryGray};
    padding: 0.89vw 0.73vw;
    margin-bottom: 1.04vw;
  }

  .iconHolder {
    display: flex;
    width: 10.42vw;
    height: 10.42vh;
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 7%;
    justify-content: center;
    align-items: center;
    svg {
      padding: 0.9vw;
      font-size: 10vw !important;
      width: 10.42vw !important;
      height: 10.42vh !important;
    }
  }
  .details {
    width: 30vw;
    display: flex;
    flex-direction: column;
    gap: 0.2vw;

    .p {
      display: flex;
      flex-direction: row;
      align-items: flex-start; /* Promijenjeno sa center na flex-start */
      padding: 0.15vw 2.4vw;
      font-size: 0.53vw;
      line-height: 1.2; /* Malo povećan line-height za bolju čitljivost */
      min-height: auto;
      margin: 0;

      h1 {
        font-size: 0.83vw;
        font-family: 'FontMedium';
        font-weight: normal;
        color: ${({ theme }) => theme.primaryGray};
        margin: 0 0.5vw 0 0;
        line-height: 1.2;
        width: 5vw; /* Fiksirana širina za konzistentnost */
        flex-shrink: 0; /* Sprječava smanjivanje */
      }

      span {
        font-size: 0.83vw;
        word-break: break-word;
        line-height: 1.2;
        padding: 0;
        margin: 0;
        flex: 1; /* Uzima ostatak prostora */
      }
    }
  }

  > button {
    position: absolute;
    bottom: 4vh;
    right: 4vw;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  & {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .action-buttons-container-fetch {
    display: flex;
    flex-direction: row;
    justify-content: flex-end; /* Poravnajte gumbe desno */
    gap: 10px; /* Razmak između gumba */
    margin-top: auto;
    padding: 20px;
  }
`;

export const ResultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 2vh;
  padding: 1.04vw;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  margin-bottom: 1.04vw;
  .table {
    margin-top: 2vh;
    height: 80vh;
    width: 100%;
    padding: 2vw;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      background-color: ${({ theme }) => theme.placeholderBackground};
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 20px;
      background-color: ${({ theme }) => theme.scrollThumb};
    }

    table {
      border-collapse: collapse;
    }

    tr {
      font-family: 'FontRegular', sans-serif;
      white-space: nowrap;
      color: ${({ theme }) => theme.primaryGray};
      border-bottom: 1px solid ${({ theme }) => theme.border};
    }

    tbody > tr > td {
      padding: 0.5vw 0.7vw;
      font-size: 0.7vw;
      color: ${({ theme }) => theme.primaryGray};
      font-family: 'FontRegular', sans-serif;
      border-bottom: 1px solid ${({ theme }) => theme.border};
      border-collapse: collapse;
    }
    th {
      color: ${({ theme }) => theme.primaryGray};
      padding: 0.5vw 0.7vw;
      font-size: 0.9vw;
      font-family: 'FontBold', sans-serif;
      border-bottom: none;
      text-align: left;
    }
    tbody > tr:nth-last-child(1) > td {
      border-bottom: none;
    }
    th {
      /* padding: 12px; */
      font-size: 0.9vw;
    }
    tr:hover > td {
      background-color: ${({ theme }) => theme.background};
    }
    thead > tr > th {
      border-bottom: 1px solid ${({ theme }) => theme.border};
      border-collapse: collapse;
      padding: 0.5vw 0.7vw;
    }
    tfoot > tr > td {
      padding: 1vw 0.7vw;
      font-size: 0.9vw;
      font-family: 'FontBold', sans-serif;
      font-weight: bold;
    }
  }
  .comment {
    width: 98%;
    padding: 1.04vw;
    /* height: 30vh; */
    textarea {
      width: 100%;
      min-height: 100px;
      border-radius: 7px;
      resize: none;
      padding: 8px;
      border: 1px solid ${({ theme }) => theme.border};
      color: ${({ theme }) => theme.primaryGray};
      background-color: ${({ theme }) => theme.background};
      font-size: 16px;
      font-family: 'FontRegular', sans-serif;
      font-weight: normal;
      font-style: normal;
    }
    textarea:focus,
    input:focus {
      outline: 1px solid ${({ theme }) => theme.border};
    }
  }
  .actionButtons {
    display: flex;
    flex-direction: row;
    align-self: flex-end;
    gap: 0.5vw;
    margin-right: 2vw;
  }
  /* .backButton {
    position: absolute;
    bottom: 2vw;
    right: 2vw;
  } */
`;

export const KPIResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1.5vw 2vw;
  gap: 1.2vw;
  overflow: hidden;

  .kpi-title-row {
    display: flex;
    flex-direction: column;
    gap: 0.3vw;

    label {
      font-size: 0.73vw;
      font-family: 'FontMedium';
      color: ${({ theme }) => theme.primaryGray};
    }

    input {
      font-size: 0.83vw;
      padding: 0.4vw 0.6vw;
      border: 1px solid ${({ theme }) => theme.border};
      border-radius: 6px;
      background: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.primaryGray};
      font-family: 'FontRegular';
      width: 20vw;

      &:focus {
        outline: 1px solid ${({ theme }) => theme.brand};
      }
    }
  }

  .kpi-preview-box {
    display: flex;
    flex-direction: column;
    gap: 0.3vw;
    padding: 0.8vw 1.2vw;
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 8px;
    background: ${({ theme }) => theme.placeholderBackground};
    width: fit-content;
    min-width: 12vw;

    .kpi-metric-label {
      font-size: 0.73vw;
      font-family: 'FontMedium';
      color: ${({ theme }) => theme.primaryGray};
    }

    .kpi-metric-value {
      font-size: 1.8vw;
      font-family: 'FontBold';
      color: ${({ theme }) => theme.brand};
    }

    .kpi-no-selection {
      font-size: 0.73vw;
      color: ${({ theme }) => theme.primaryGray};
      opacity: 0.6;
      font-style: italic;
    }
  }

  .kpi-row-picker-section {
    display: flex;
    flex-direction: column;
    gap: 0.5vw;
    flex: 1;
    overflow: hidden;

    .kpi-row-picker-label {
      font-size: 0.73vw;
      font-family: 'FontMedium';
      color: ${({ theme }) => theme.primaryGray};
    }

    .kpi-row-picker-list {
      display: flex;
      flex-direction: column;
      gap: 0.3vw;
      overflow-y: auto;
      max-height: 35vh;

      &::-webkit-scrollbar {
        width: 4px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 20px;
        background-color: ${({ theme }) => theme.scrollThumb};
      }
    }
  }

  .kpi-action-buttons {
    display: flex;
    flex-direction: row;
    gap: 0.6vw;
    margin-top: auto;
    justify-content: flex-end;
    padding-top: 0.5vw;
    border-top: 1px solid ${({ theme }) => theme.border};
  }
`;

export const KPIRowPickerItem = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.5vw 0.8vw;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid ${({ theme, selected }) => (selected ? theme.brand : theme.border)};
  background: ${({ theme, selected }) => (selected ? `${theme.brand}15` : theme.background)};
  transition: all 0.15s ease;
  width: fit-content;
  min-width: 18vw;
  max-width: 40vw;

  &:hover {
    border-color: ${({ theme }) => theme.brand};
    background: ${({ theme }) => theme.c50};
  }

  .row-dimension-value {
    font-size: 0.73vw;
    font-family: 'FontMedium';
    color: ${({ theme }) => theme.primaryGray};
    flex: 1;
  }

  .row-metric-value {
    font-size: 0.73vw;
    font-family: 'FontBold';
    color: ${({ theme }) => theme.brand};
    margin-left: 1.5vw;
  }

  .row-radio {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid ${({ theme, selected }) => (selected ? theme.brand : theme.border)};
    margin-left: 0.8vw;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      display: ${({ selected }) => (selected ? 'block' : 'none')};
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: ${({ theme }) => theme.brand};
    }
  }
`;

export const MetricRenameInput = styled.input`
  margin-left: 0.4vw;
  padding: 0.2vw 0.4vw;
  font-size: 0.6vw;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 4px;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.primaryGray};
  font-family: 'FontRegular';
  width: 7vw;

  &:focus {
    outline: 1px solid ${({ theme }) => theme.brand};
  }
`;

export const StatusToast = styled.div`
  position: absolute;
  bottom: 3vh;
  margin: auto;
  background-color: ${({ theme }) => theme.background};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 7px;
  padding: 0.8vw;
  padding-left: 1.44vw;
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
  // centering
  left: 50%;
  transform: translateX(-50%);
  .colorIndicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 0.5vw;
    height: 100%;
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;

    background-color: green;
  }

  h1 {
    font-size: 1.04vw;
    font-family: 'FontMedium';
    font-weight: normal;
    color: ${({ theme }) => theme.primaryGray};
  }
  p {
    font-size: 0.8vw;
    font-family: 'FontRegular';
    font-weight: normal;
    color: ${({ theme }) => theme.primaryGray};
  }
`;
